module.exports = '<svg width="38" height="32" viewBox="0 0 38 32"><path d="M20.521 31.297a2.247 2.247 0 0 1-3.267 0L2.768 16.214c-3.691-3.712-3.691-9.724 0-13.432a9.423 9.423 0 0 1 13.368 0l2.75 3.358 2.75-3.358a9.423 9.423 0 0 1 13.368 0c3.691 3.708 3.691 9.719 0 13.432L20.521 31.297z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/heart-1.js
// module id = 1170
// module chunks = 14